import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';

const SrLinkUrlButton = ({ buttonText, href, className, hideUrl }) => {
  const [clickedMessageActive, setClickedMessageActive] = useState(false);

  const handleClick = () => {
    copyToClipboard(href);
    setClickedMessageActive(true);
    setTimeout(() => {
      setClickedMessageActive(false);
    }, 2000);
  };

  return (
    <span
      className={classnames('SrLinkUrlButtonContainer', className, {
        clickedMessageActive,
        hideUrl,
      })}
      onClick={handleClick}
    >
      <span className="link">{href.slice()}</span>
      <div className="linkUrlButton">{clickedMessageActive ? 'Copied!' : buttonText}</div>
    </span>
  );
};

SrLinkUrlButton.propTypes = {
  hideUrl: PropTypes.bool,
  buttonText: PropTypes.string,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SrLinkUrlButton.defaultProps = {
  buttonText: 'Copy Link',
  hideUrl: false,
};

export default SrLinkUrlButton;
